import React, { useState, useEffect, useRef }           from 'react';
import CustomAutocomplete                       from '../fields/CustomAutocomplete';
import { Check, Close, Download, FastRewind }   from '@mui/icons-material';
import HourglassEmptyIcon                       from '@mui/icons-material/HourglassEmpty';
import CustomTextFieldModifica                  from '../fields/CustomTextFieldModifica';
import dayjs                                    from 'dayjs';
import JSZip                                    from 'jszip';
import { saveAs }                               from 'file-saver';
import SendAvviso                               from '../SendAvviso';
import SendEmail                                from '../SendEmail';
import { useTranslation }                       from 'react-i18next';
import CustomNoteAggiungi2                      from '../fields/CustomNoteAggiungi2';
import axios                                    from 'axios';


import {
    Modal,
    Box,
    Button,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    Stepper,
    Step,
    StepLabel,
    Grid,
    Tooltip,
    IconButton,
    Chip,
    Divider,
    Snackbar,
    Alert,
    TableHead,
} from '@mui/material';
import ApiService from '../service/ApiService';


const RiparazioniDOAEditModal = ({ open, onClose, selectedRMA, handleSave }) => {

    

    const getStepIndex = (stato) => {
        switch (stato) {
            case 'IN_ATTESA':
                return 0;
            case 'IN_LAVORAZIONE':
                return 1;
            case 'ACCETTATO_INVIO_CLIENTE':
            case 'ACCETTATO_ATTESA_INFO_RITIRO':
                return 2;
            case 'ACCETTATO':
            case 'RIFIUTATO':
            case 'RINVIATO':
                return 3;
            case 'RIMBORSATO':
                return 4;
            default:
                return 0;
        }
    };

    const [datiRMA,             setDatiRMA          ] = useState({});
    const [activeStep,          setActiveStep       ] = useState(getStepIndex(selectedRMA?.stato || ''));
    const [isModified,          setIsModified       ] = useState(false);
    const [alert,               setAlert            ] = useState({ open: false, message: '', severity: 'success' });
    const [loading,             setLoading          ] = useState(true);
    const [openSnackbar,        setOpenSnackbar     ] = useState(false);
    const [message,             setMessage          ] = useState('');
    const [snackbarSeverity,    setSnackbarSeverity ] = useState('success');
    const [note,                setNote             ] = useState("");
    const [view,                setView             ] = useState('datiReso');
    const [motivoRifiuto,       setMotivoRifiuto    ] = useState("");


    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const headers = {
        Authorization: `Bearer ${token}`
    };

    const idCliente = selectedRMA?.cliente?.id;

    const { t } = useTranslation();

    const modalRef = useRef(null);

    useEffect(() => {
        if (open && modalRef.current) {
            modalRef.current.scrollTop = 0;
        }
    }, [open]);
    
    
    useEffect(() => {
        if (open && selectedRMA) {
            fetchDatiRMA();
        }
    }, [open, selectedRMA]);

    const fetchDatiRMA = async () => {
        setLoading(true);
        try {
            // const response = await axios.get(`http://localhost:8080/rma/${selectedRMA?.id}`, { headers: headers });
            const response = await ApiService.request("getRmaID", { idRma: selectedRMA?.id});
            

            const rmaData = response.data;
            setDatiRMA(rmaData);
        } catch (error) {
            console.error("Errore nel recupero dei dati RMA", error);
        } finally {
            setLoading(false);
        }
    };

    

    const steps = [
        t('In attesa'),
        t('In lavorazione'),
        t('Accettato invio cliente'),
        t('Accettato'),
        t('Rimborsato')
    ];
    


    const dynamicSteps = (step, index) => {
        if (index === 2 && datiRMA.stato === "ACCETTATO_ATTESA_INFO_RITIRO") return t('Accettato attesa info ritiro');
        if (index === 3 && datiRMA.stato === "RIFIUTATO") return t('Rifiutato');
        if (index === 3 && datiRMA.stato === "RINVIATO") return t('Rinviato');
        return step;
    };
    

    useEffect(() => {
        if (!isModified) {
            setDatiRMA((prevDatiRMA) => ({
                ...prevDatiRMA,
                id: selectedRMA?.id,
                tipologia: selectedRMA?.tipologia || '',
                stato: selectedRMA?.stato || prevDatiRMA.stato, 
            }));
            setActiveStep(getStepIndex(selectedRMA?.stato || ''));
        }
    }, [selectedRMA, isModified]);
    

    useEffect(() => {
        if (datiRMA.stato === 'IN_ATTESA') {
            const nuovoStato = 'IN_LAVORAZIONE';
            setDatiRMA((prevDatiRMA) => ({
                ...prevDatiRMA,
                stato: nuovoStato,
            }));
            setActiveStep(getStepIndex(nuovoStato)); 
            setIsModified(true); 
        }
    }, [datiRMA]);
    
    


    // const handleInputChange = (name, newValue) => {
    //     setDatiRMA((prevDatiRMA) => ({
    //         ...prevDatiRMA,
    //         [name]: newValue[name]
    //     }));
    //     setActiveStep(getStepIndex(newValue));
    //     setIsModified(true);
    // };

    const handleInputChange = (name, newValue) => {
        setDatiRMA((prevDatiRMA) => ({
            ...prevDatiRMA,
            [name]: newValue[name],
        }));
    
        if (name === "tipologia" && newValue[name] === "RIPARAZIONE" && datiRMA?.tipologia === "DOA") {
            setNote(""); 
        }
    
        setActiveStep(getStepIndex(newValue));
        setIsModified(true);
    };
    
    

    const formatData = (data) => {
        return dayjs(data).format('DD/MM/YYYY');
    };    

    const handleSaveModifiche = () => {
        const idReso = selectedRMA?.idReso;
        const destinatario = selectedRMA?.cliente?.emailPersonaContatto;
        const idDestinatario = selectedRMA?.cliente?.id;
    
        // Switch per `datiRMA?.stato`
        switch (datiRMA?.stato) {
            case "RIFIUTATO":
                if (motivoRifiuto.trim() !== "") {
                    const messaggio = motivoRifiuto;
                    // Invio email per rifiuto
                    // SendEmail(
                    //     idReso,
                    //     destinatario,
                    //     messaggio,
                    //     "RIFIUTO_RICHIESTA",
                    //     () => {
                    //         setMessage(t("Email inviata con successo!"));
                    //         setSnackbarSeverity("success");
                    //         setOpenSnackbar(true);
                    //     },
                    //     () => {
                    //         setMessage(t("Errore nell'invio dell'email. Riprova più tardi."));
                    //         setSnackbarSeverity("error");
                    //         setOpenSnackbar(true);
                    //     }
                    // );
    
                    SendAvviso(
                        idReso,
                        idDestinatario,
                        "AVVISO_RIFIUTO",
                        () => {
                            setMessage(t("Avviso inviato al cliente con successo!"));
                            setSnackbarSeverity("success");
                            setOpenSnackbar(true);
                        },
                        () => {
                            setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                            setSnackbarSeverity("error");
                            setOpenSnackbar(true);
                        }
                    );
                } else {
                    setMessage(t("Inserire un motivo per il rifiuto."));
                    setSnackbarSeverity("warning");
                    setOpenSnackbar(true);
                    return;
                }
                break;

                case "ACCETTATO_INVIO_CLIENTE": {
                    const messaggioAccettatoInvioCliente = `Gentile cliente,\nLa sua richiesta #${idReso} è stata respinta. Di seguito il motivo fornito:\n\n"${motivoRifiuto}".\n\nPer ulteriori informazioni, non esiti a contattarci.`;
    
                    // Invio email per rifiuto
                    // SendEmail(
                    //     idReso,
                    //     destinatario,
                    //     messaggioAccettatoInvioCliente,
                    //     "ACCETTATO_INVIO",
                    //     () => {
                    //         setMessage(t("Email inviata con successo!"));
                    //         setSnackbarSeverity("success");
                    //         setOpenSnackbar(true);
                    //     },
                    //     () => {
                    //         setMessage(t("Errore nell'invio dell'email. Riprova più tardi."));
                    //         setSnackbarSeverity("error");
                    //         setOpenSnackbar(true);
                    //     }
                    // );
    
                    SendAvviso(
                        idReso,
                        idDestinatario,
                        "AVVISO_ACCETTATO_INVIO",
                        () => {
                            setMessage(t("Avviso inviato al cliente con successo!"));
                            setSnackbarSeverity("success");
                            setOpenSnackbar(true);
                        },
                        () => {
                            setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                            setSnackbarSeverity("error");
                            setOpenSnackbar(true);
                        }
                    );
                    break;
                }

                case "ACCETTATO_ATTESA_INFO_RITIRO": {
                    const messaggio = null;
        
                        // Invio email per rifiuto
                        // SendEmail(
                        //     idReso,
                        //     destinatario,
                        //     messaggio,
                        //     "ACCETTATO_RITIRO",
                        //     () => {
                        //         setMessage(t("Email inviata con successo!"));
                        //         setSnackbarSeverity("success");
                        //         setOpenSnackbar(true);
                        //     },
                        //     () => {
                        //         setMessage(t("Errore nell'invio dell'email. Riprova più tardi."));
                        //         setSnackbarSeverity("error");
                        //         setOpenSnackbar(true);
                        //     }
                        // );
        
                        SendAvviso(
                            idReso,
                            idDestinatario,
                            "AVVISO_ACCETTATO_RITIRO",
                            () => {
                                setMessage(t("Avviso inviato al cliente con successo!"));
                                setSnackbarSeverity("success");
                                setOpenSnackbar(true);
                            },
                            () => {
                                setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                                setSnackbarSeverity("error");
                                setOpenSnackbar(true);
                            }
                        );
                    break;
                }
            default:
                break;
        }
    
        // Switch per `datiRMA?.tipologia`
        switch (datiRMA?.tipologia) {
            case "RIPARAZIONE":
                if (selectedRMA?.tipologia === "DOA" && note.trim() !== "") {
                    const messaggio = note;
                    // SendEmail(
                    //     idReso,
                    //     destinatario,
                    //     messaggio,
                    //     "MODIFICA_RICHIESTA",
                    //     () => {
                    //         setMessage(t("Email inviata con successo!"));
                    //         setSnackbarSeverity("success");
                    //         setOpenSnackbar(true);
                    //     },
                    //     () => {
                    //         setMessage(t("Errore nell'invio dell'email. Riprova più tardi."));
                    //         setSnackbarSeverity("error");
                    //         setOpenSnackbar(true);
                    //     }
                    // );
                }
                break;
    
            default:
                break;
        }
    
        const messaggioDefault = `Aggiornamento Stato Reso #${idReso}`;
    
        // Invio email generica
        // SendEmail(
        //     idReso,
        //     destinatario,
        //     messaggioDefault,
        //     "MODIFICA_RMA",
        //     () => {
        //         setMessage(t("Email di contatto inviata con successo!"));
        //         setSnackbarSeverity("success");
        //         setOpenSnackbar(true);
        //     },
        //     () => {
        //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
        //         setSnackbarSeverity("error");
        //         setOpenSnackbar(true);
        //     }
        // );
    
        // Invio avviso generico
        SendAvviso(
            idReso,
            idDestinatario,
            "AVVISO_MODIFICA_SAT",
            () => {
                setMessage(t("Avviso inviato al cliente con successo!"));
                setSnackbarSeverity("success");
                setOpenSnackbar(true);
            },
            () => {
                setMessage(t("Errore nell'invio dell'avviso. Per favore, riprova."));
                setSnackbarSeverity("error");
                setOpenSnackbar(true);
            }
        );
    
        handleSubmit();
    };
    
    

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };


    const handleSubmit = async () => {
        
        if (isModified) {
            try {
                const formattedFormData = {
                    ...datiRMA,
                    dataFattura: datiRMA?.dataFattura ? formatData(datiRMA.dataFattura) : null,
                    dataRicezioneMerce: datiRMA?.dataRicezioneMerce ? formatData(datiRMA.dataRicezioneMerce) : null,
                    richiestaIndirizzo: datiRMA?.stato === "ACCETTATO_ATTESA_INFO_RITIRO" ? true : false
                };
                delete formattedFormData.files;

                const response = await axios.post(`/rma/salva/${idCliente}`, formattedFormData, { headers: headers });
                // const response = await ApiService.request("rmaClienteSave", {idCliente: idCliente}, formattedFormData);
                
                handleSave(formattedFormData);
            } catch (error) {
                setAlert({ open: true, message: "Errore durante il salvataggio del reso.", severity: 'error' });
                setTimeout(() => setAlert({ ...alert, open: false }), 6000);
            }
        }
        onClose();
    };

    const tipologiaOptions = [
        { label: t('DOA'),         value: 'DOA' },
        { label: t('Riparazione'), value: 'RIPARAZIONE' }
    ];
    

    const showTipologiaAutocomplete = ['DOA'].includes(datiRMA?.tipologia);

    const statoOptions = [
        { label: t('In Attesa'),                       value: 'IN_ATTESA'                      },
        { label: t('In Lavorazione'),                  value: 'IN_LAVORAZIONE'                 },
        { label: t('Accettare: invia il cliente'),     value: 'ACCETTATO_INVIO_CLIENTE'        },
        { label: t('Accettare: ritiriamo noi'),        value: 'ACCETTATO_ATTESA_INFO_RITIRO'   },
        { label: t('Realizza ritiro'),                 value: 'ACCETTATO'                      },
        { label: t('Rifiutato'),                       value: 'RIFIUTATO'                      },
        { label: t('Rinviato a cliente'),              value: 'RINVIATO'                       },
        { label: t('Rimborsato'),                      value: 'RIMBORSATO'                     }
    ];

    const fields = [
        { label: t('Tipologia'),       name: 'tipologia',  type: `${showTipologiaAutocomplete ? 'select' : 'text'}`, options: tipologiaOptions },
        { label: t('Stato richiesta'), name: 'stato',      type: 'select',                                           options: statoOptions     },
    ];

    const renderFields = (field) => {
        const { name, label, type, options, ...otherProps } = field;
    
        switch (type) {
            case 'text':
                return (
                    <CustomTextFieldModifica
                        key={name}
                        name={name}
                        label={label}
                        values={datiRMA[name] || ''}
                        initialValues={datiRMA}
                        onChange={(newValue) => handleInputChange(name, newValue)}
                        {...otherProps}
                        disabled={true}
                    />
                );
            case 'select':
                return (
                    <CustomAutocomplete
                        key={name}
                        name={name}
                        label={label}
                        value={datiRMA[name]}
                        options={options || []}
                        onChange={(newValue) => handleInputChange(name, newValue)}
                    />
                );
            default:
                return null;
        }
    };

    const CustomStepIcon = (props) => {
        const { active, completed } = props;

        if (completed) {
            return <Check sx={{ background: '#32976b', color: '#fff', borderRadius: '50%' }} />;
        }

        if (active) {
            switch (datiRMA.stato) {
                case 'IN_ATTESA':
                case 'IN_LAVORAZIONE':
                    return <HourglassEmptyIcon  sx={{ background: '#FDA03D', color: '#fff', borderRadius: '50%' }} />;
                case 'RINVIATO':
                    return <FastRewind          sx={{ background: '#FDA03D', color: '#fff', borderRadius: '50%' }} />;
                case 'RIFIUTATO':
                    return <Close               sx={{ background: '#952828', color: '#fff', borderRadius: '50%' }} />
                default:
                    return <Check               sx={{ background: '#32976b', color: '#fff', borderRadius: '50%' }} />;
            }
        }

        return <Check sx={{ background: '#ccc', color: '#fff', borderRadius: '50%' }} />;
    };

    const handleDownloadZip = async (datiRMA, nomeCliente) => {
        
        const zip = new JSZip();
        const zipFolder = zip.folder(`${nomeCliente}_${selectedRMA?.idReso}`);

        try {
            const filePromises = datiRMA.files.map(async (file) => {
                const response = await fetch(`data:application/octet-stream;base64,${file.data}`);
                const blob = await response.blob();
                zipFolder.file(file.descrizione, blob);
            });

            await Promise.all(filePromises);
            const zipBlob = await zip.generateAsync({ type: 'blob' });
            saveAs(zipBlob, `${nomeCliente}_${selectedRMA?.idReso}.zip`);
        } catch (error) {
            console.error("Errore nel download delle immagini", error);
        }
    };


    const fieldMapping = {
        "ragioneSociale":       t("Ragione Sociale"),
        "personaContatto":      t("Persona di Contatto"),
        "id":                   t("ID Cliente"),
        "emailPersonaContatto": t("Email Persona di Contatto"),
        "dataFattura":          t("Data della Fattura"),
        "numeroFatturaReal":    t("Numero della Fattura"),
        "numeroFattura":        t("Numero Interno della Fattura"),
        "descrizioneProblema":  t("Descrizione del Problema"),
        "idReso":               t("Reso"),
        "tipologia":            t("Tipologia"),
        "piva":                 t("Partita iva"),
        "commerciale.nome":     t("Nome del Commerciale"),
        "commerciale.email":    t("Email del Commerciale"),
    };
    

    const excludedKeys = ["commerciale.user", "commerciale.id"];

    const isExcluded = (key) => {
        return excludedKeys.some((excludedKey) => key === excludedKey);
    };
    


    return (
        <Box
            className="modal-container"
            sx={{
                px: 4,
                backgroundColor: 'white',
                borderRadius: 2,
                margin: 'auto',
                overflowY: 'auto',

            }}
        >
        <Modal open={open} onClose={onClose}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
            <Box sx={{
                px: 4,
                backgroundColor: 'white',
                borderRadius: 2,
                maxWidth: '85%',
                maxHeight: '95%',
                margin: 'auto',
                overflowY: 'auto',
                border: 'solid 2px #bdbdbd',
                width:'90vw',


            }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontSize={25} my={3} sx={{ fontWeight: 'bold', color: '#FDA03D'}}>
                    {t('Dettagli Reso')}
                    </Typography>
                    <Button onClick={onClose}
                        sx={{
                            position: 'relative',
                            top: 0,
                            right: 0,
                            bgcolor: 'white'
                        }}>
                        <Close sx={{
                            color: '#CCCCCC',
                            '&:hover': {
                                color: 'red',
                            }
                        }} />
                    </Button>
                </Box>

                {/* Stepper */}
                <Table sx={{ my: 5 }}>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ paddingBottom: 0, paddingTop: 0, border: 0 }} >
                                <Box>
                                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: '#263F78', my: 1}}>
                                    {t('Stato RMA')}
                                    </Typography>
                                    <Stepper activeStep={getStepIndex(datiRMA.stato)} alternativeLabel>
                                        {steps.map((step, index) => (
                                            <Step key={index}>
                                                <StepLabel StepIconComponent={CustomStepIcon}>
                                                    {dynamicSteps(step, index)}
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.3)' }} />
                {/* Form */}
                <Box sx={{ width: '100%' }}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', color: '#263F78', paddingBottom: 3 }}>
                    {t('Modifica RMA')}
                    </Typography>
                    <Grid container spacing={2}>
                        {fields.map((field) => (
                            <Grid item xs={12} sm={field.type === 'note' ? 12 : 6} key={field.name}>
                                {renderFields(field)}
                            </Grid>
                        ))}
                            {datiRMA && selectedRMA?.tipologia === "DOA" && datiRMA?.tipologia === "RIPARAZIONE" && (
                            <>
                            <Grid item xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, color: '#263F78' }}>
                                {t('Inserisci il motivo per la modifica:')}
                                </Typography>
                                <CustomNoteAggiungi2
                                    name="note"
                                    label="Motivo della modifica"
                                    value={note || ''}
                                    onChange={(e) => {
                                        setNote(e.target.value); 
                                    }}
                                    fullWidth
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                            </>
                        )}
                        {datiRMA?.stato === "RIFIUTATO" && (
                            <Grid item xs={12}>
                                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, color: '#263F78' }}>
                                {t('Inserisci il motivo del rifiuto:')}
                                </Typography>
                                <CustomNoteAggiungi2
                                    name="motivoRifiuto"
                                    label="Motivo del rifiuto"
                                    value={motivoRifiuto}
                                    onChange={(e) => setMotivoRifiuto(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                        )}

                    </Grid>
                </Box>
                <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.3)' }} />
                {/* Chip */}
                <Box
    sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f0f0f0",
        borderRadius: "20px",
        padding: "4px",
        width: "fit-content",
        position: "relative",
        gap: 2,
        mb: 2,
    }}
>
    <Box
        sx={{
            position: "absolute",
            top: "4px",
            bottom: "4px",
            left: view === "datiReso" ? "4px" : "50%",
            width: "50%",
            borderRadius: "16px",
            backgroundColor: "#FDA03D",
            transition: "all 0.3s ease",
        }}
    />
    <Button
        onClick={() => setView("datiReso")}
        sx={{
            flex: 1,
            borderRadius: "20px",
            backgroundColor: "transparent",
            color: view === "datiReso" ? "white" : "black",
            fontWeight: view === "datiReso" ? "bold" : "normal",
            textTransform: "none",
            padding: "8px 16px",
            zIndex: 1,
            "&:hover": {
                backgroundColor: "transparent",
            },
        }}
    >
        {t("Dati Reso")}
    </Button>
    <Button
        onClick={() => setView("datiCliente")}
        sx={{
            flex: 1,
            borderRadius: "20px",
            backgroundColor: "transparent",
            color: view === "datiCliente" ? "white" : "black",
            fontWeight: view === "datiCliente" ? "bold" : "normal",
            textTransform: "none",
            padding: "8px 16px",
            zIndex: 1,
            "&:hover": {
                backgroundColor: "transparent",
            },
        }}
    >
        {t("Dati Cliente")}
    </Button>
</Box>

<Grid container spacing={2} p={1}>
<Box sx={{mb:2, padding: 2, border: 'solid 1px #bdbdbd', borderRadius: '20px', overflowY: 'auto', width: '100%' }} >
    {view === "datiReso" && (
        <>
         <Grid container spacing={2} p={1}>
            {Object.entries(datiRMA)
                .filter(([key, value]) => 
                        value !== null && value !== "" && key !== "files" && key !== "prodotti" 
                        && key !== "richiestaIndirizzo" && key !== "richiestaIntegrazione"
                )         
                .map(([key, value]) => (
                    <Grid item lg={6} sx={{ p: 1 }} key={key}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {fieldMapping[key] || key}:
                        </Typography>
                        <Chip label={`${value}`} sx={{ background: "#ededed", mt: 1 }} />
                    </Grid>
                ))}
            {datiRMA.prodotti && (
                <Grid item lg={12} sx={{ p: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>{t('Prodotti')}:</Typography>
                    <Table sx={{ background: "#f9f9f9", borderRadius: "10px", overflow: "hidden", border: '1px solid #BDBDBD' }}>
                        {/* Intestazione della tabella */}
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{t('Descrizione')}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{t('SKU/EAN')}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{t('IMEI/Serial')}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{t('Quantità')}</Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        {/* Corpo della tabella */}
                        <TableBody>
                            {datiRMA.prodotti.map((prodotto, index) => (
                                <TableRow key={index}>
                                    <TableCell>{prodotto.descrizione || '--'}</TableCell>
                                    <TableCell>{prodotto.skuEan || '--'}</TableCell>
                                    <TableCell>{prodotto.imeiSerial || '--'}</TableCell>
                                    <TableCell>{prodotto.quantita !== null ? prodotto.quantita : '--'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Grid>
            )}

            <Tooltip title="File">
                            <Box sx={{ display: 'flex', alignItems: 'center', m: 1 }}>
                                <Typography variant='h6'>{t('Scarica File')}</Typography>
                                <IconButton onClick={() => handleDownloadZip(datiRMA, selectedRMA?.cliente?.ragioneSociale)}
                                    sx={{
                                        '&:hover': {
                                            color: '#FDA03D',
                                            bgcolor: 'transparent',
                                        },
                                    }}
                                >
                                    <Download />
                                </IconButton>
                            </Box>
                        </Tooltip>
                        </Grid>
        </>
    )}
    {view === "datiCliente" && (
    <Grid container spacing={2} p={1}>
        <>
        {Object.entries(selectedRMA?.cliente || {}).map(([key, value]) => {
            if (key === "commerciale" || isExcluded(key)) {
            return null;
            }

            if (value !== null && typeof value === "object") {
            return Object.entries(value).map(([nestedKey, nestedValue]) => {
                const fullKey = `${key}.${nestedKey}`;
                if (isExcluded(fullKey)) return null;

                return (
                <Grid item lg={6} key={fullKey} sx={{ p: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {fieldMapping[fullKey] || fullKey}:
                    </Typography>
                    <Chip
                    label={nestedValue !== null ? `${nestedValue}` : "--"}
                    sx={{ background: "#ededed", mt: 1 }}
                    />
                </Grid>
                );
            });
            }

            return (
            <Grid item lg={6} key={key} sx={{ p: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {fieldMapping[key] || key}:
                </Typography>
                <Chip label={value !== null ? `${value}` : "--"} sx={{ background: "#ededed", mt: 1 }} />
            </Grid>
            );
        })}


        {selectedRMA?.cliente?.commerciale && (
            <Grid item lg={6} key="commerciale.nomeCompleto" sx={{ p: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                {t("Nome del Commerciale")}:
            </Typography>
            <Chip
                label={
                [selectedRMA.cliente.commerciale.nome, selectedRMA.cliente.commerciale.cognome]
                    .filter(Boolean)
                    .join(" ") || "--"
                }
                sx={{ background: "#ededed", mt: 1 }}
            />
            </Grid>
        )}
        </>


        {/* {Object.entries(selectedRMA?.cliente || {}).map(([key, value]) => {
            if (value !== null && typeof value === "object") {
                // Gestione oggetti annidati come "commerciale"
                return Object.entries(value).map(([nestedKey, nestedValue]) => {
                    const fullKey = `${key}.${nestedKey}`;
                    if (isExcluded(fullKey)) {
                        return null; 
                    }
                    return (
                        <Grid item lg={6} key={fullKey} sx={{ p: 1 }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                {fieldMapping[fullKey] || fullKey}:
                            </Typography>
                            <Chip label={nestedValue !== null ? `${nestedValue}` : "--"} sx={{ background: "#ededed", mt: 1 }} />
                        </Grid>
                    );
                });
            }

            if (isExcluded(key)) {
                return null; 
            }

            return (
                <Grid item lg={6} key={key} sx={{ p: 1 }}>
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        {fieldMapping[key] || key}:
                    </Typography>
                    <Chip label={value !== null ? `${value}` : "--"} sx={{ background: "#ededed", mt: 1 }} />
                </Grid>
            );
        })} */}
    </Grid>
)}


    </Box>
</Grid>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box sx={{ textAlign: 'right' }}>
                            <Button variant="contained" 
                            sx={{
                            borderRadius: '10px',
                            width: '10em',
                            backgroundColor: "#213d72", 
                            color: "#ffffff", 
                            mb: 4,
                            "&:hover": {
                                backgroundColor: "#1a315b", 
                                transform: "scale(1.05)",
                            },
                        }}
                        autoFocus
                        onClick={handleSaveModifiche}>{t('Salva')}</Button>
                        </Box>
                    </Box>
            </Box>
        </Modal>

        <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {message}
        </Alert>
        </Snackbar>
        </Box>
        
    );
};

export default RiparazioniDOAEditModal;
